// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Board/Content/Main/Subscribers/Content/AddEmployee/EmployeeList/data.graphql
import { gql } from 'Data/Api'

export default gql`
# get all employees
query app__App_Account_Content_Tasks_New_Content_Board_Content_Main_Subscribers_Content_AddEmployee_EmployeeList($parent_company_id: numeric!) {
  vaxiom_persons(
    where: {
      _and: [
        { user: { disabled: { _eq: false }, locked: { _eq: false } } }
        { organization_id: { _eq: $parent_company_id } }
      ]
    }
  ) {
    id
    first_name
    middle_name
    last_name
    public_user {
      id
      account {
        id
        email
      }
    }
  }
}

`